import React from 'react';
import classNames from 'classnames';

const THEME_SMALL = 'small';
const THEME_X_SMALL = 'x-small';
const THEME_TINY = 'tiny';
const ALIGNMENT_LEFT = 'left';

/**
 * Standard LegacyAvatar component
 */
const LegacyAvatar = ({
  url,
  src,
  target,
  name,
  theme,
  filled,
  children,
  alignment,
}) => {
  const className = classNames('c-avatar', {
    'c-avatar--tiny': theme === THEME_TINY,
    'c-avatar--x-small-to-base': theme === THEME_X_SMALL,
    'c-avatar--small': theme === THEME_SMALL,
    'c-avatar--filled': filled,
    'c-avatar--align-left': alignment === ALIGNMENT_LEFT,
  });

  let imgOrInitial = src ? (
    <img className="c-avatar__image" alt={name.firstname} src={src} />
  ) : (
    <span className="c-avatar__text">
      <span aria-hidden="true">{name.initials}</span>
      <span className="u-hide-visually">{name.firstname}</span>
    </span>
  );

  if (url) {
    imgOrInitial = (
      <a
        href={url}
        className="c-avatar__link"
        target={target}
        rel={target === '_blank' ? 'noopener noreferrer' : null}
      >
        {imgOrInitial}
      </a>
    );
  }

  return (
    <div>
      <div className={className}>{imgOrInitial}</div>
      {children}
    </div>
  );
};

export default LegacyAvatar;
